import { colorBrandPrimary } from 'src/global.style'
import { media } from '../../../../../layouts/utils'
import styled from 'styled-components'

export const Container = styled.div`
	margin-top: 16px;
	width: 100%;
	max-width: 550px;
	display: flex;
	flex-direction: column;
`

export const CardBody = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;

	.subtitle {
		width: 65%;
		padding-top: 0.25rem;
		font-family: 'Work Sans';
		font-size: 1.5rem;
		font-weight: 700;
		opacity: 1;
		color: ${({ blur }) => (blur ? 'transparent' : '#230C87')};
		text-shadow: ${({ blur }) => (blur ? `0 0 4px #180700` : 'none')};

		span {
			position: relative;

			&::before {
				content: '';
				position: absolute;
				top: 40%;
				right: 0;
				width: 99%;
				height: 3px;
				background-color: #230c87;
				transform: rotate(-9deg);
			}
		}

		${media.phone`
			width: 100%;
			font-size: 1rem;
    	`}
	}

	.subtitle-newPrice {
		width: 100%;
		font-size: 2rem;
		color: ${({ blur }) => (blur ? 'transparent' : '#CC092F')};

		${media.phone`
			font-size: 1.25rem;
    	`}
	}
`

export const Title = styled.div`
	margin-bottom: 24px;

	color: #230C87;
	font-family: "Platform Web";
	font-size: 20px;
	font-style: normal;
	font-weight: 500;
	line-height: 25px;

	& > span {
		color: #CC092F;
	}
`

export const Banner = styled.div`
	width: 100%;
	border-radius: 0.5rem;
	max-height: 7.625rem;
	overflow: hidden;

	display: grid;
	place-items: initial;
`
export const Benefits = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	hr {
		width: 100%;
		border: 0;
		border-top: 2px solid rgb(88, 83, 128);
		opacity: 0.16;
	}

	${media.phone`
		> div:nth-child(1) {
			order: 1;
			background: #fff;
		}

		> div:nth-child(2) {
			order: 3;
			background: #fff;
		}

		> div:nth-child(3) {
			order: 4;
		}

		> div:nth-child(4) {
			order: 2;
		}
	`}
`

export const Benefit = styled.p`
	margin-bottom: 16px;
	position: relative;

	color: #230C87;
	font-family: "Work Sans";
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;

	span {
		cursor: pointer;
		text-decoration: underline;

		img {
			position: relative;
			top: 2px;
		}
	}
`

export const Item = styled.div`
	display: flex;
	flex-direction: row;
	align-items: baseline;
	gap: 7px;
	width: 100%;
`

export const TooltipContent = styled.div`
	position: absolute;
	left: -20px;
	display: flex;
	flex-direction: column;
	padding: 15px;

	z-index: 1;
	border-radius: 7.601px;
	border: 0.95px solid rgba(241, 243, 247, 0.80);

	box-shadow: 0px 0px 19px -3px rgba(13, 13, 13, 0.09);
	background: #FAFAFA;
`
